import {
  CompanyPageSourceDerivedSectionAttributes,
  GenerateAsOption,
  GroupByOption,
  PageTemplateSectionSource,
} from 'api/custom-section/types';
import { CustomSectionComponentProps } from '../../../types';

export interface Configuration {
  groupBy: GroupByOption;
  generateAs: GenerateAsOption;
  sourcePageTemplateSections: PageTemplateSectionSource[];
}
export interface PromptInputFormValues {
  title: string;
  config: Configuration;
}

export const defaultConfiguration: Configuration = {
  groupBy: GroupByOption.Topics,
  generateAs: GenerateAsOption.Paragraph,
  sourcePageTemplateSections: [],
};

export type CompanyPageSourceDerivedSectionComponentProps =
  CustomSectionComponentProps<CompanyPageSourceDerivedSectionAttributes>;
